import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { LeadsActions } from ".";
import { CLEAR_LEAD_FROM_WEBSITE_STATE, FETCH_LEAD_FAILED, FETCH_LEAD_SUCCESS, FETCH_LEADS_FROM_WEBSITE_FAILED, FETCH_LEADS_FROM_WEBSITE_PROGRESS, FETCH_LEADS_FROM_WEBSITE_SUCCESS } from "./leadsfromwebsiteActions";
import { initialLeadfromWebsiteState } from "./leadsfromwebsite.types";


export const leadsfromWebsiteReducer = (
    state: IStoreState["leadsfromwebsite"] = initialLeadfromWebsiteState,
    action: LeadsActions
) => {
    switch (action.type) {
        case FETCH_LEADS_FROM_WEBSITE_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        case FETCH_LEADS_FROM_WEBSITE_SUCCESS: {
            const { list, totalRecords } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.Loaded;
                draftState.list.list = list;
                draftState.list.totalRecords = totalRecords;
            });
            return newState;
        }
        case FETCH_LEADS_FROM_WEBSITE_FAILED: {
            const newState = produce(state, (draftState) => {
                draftState.list.loading = LoadState.InProgress;
                draftState.list.list = [];
                draftState.list.totalRecords = 0;
            });
            return newState;
        }
        // case FETCH_LEAD_PROGRESS: {
        //     const newState = produce(state, (draftState) => {
        //         draftState.lead.loading = LoadState.InProgress;
        //         draftState.lead.data = initialLead;
        //     });
        //     return newState;
        // }
        case FETCH_LEAD_SUCCESS: {
            const { leadfromWebsite } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.leadfromWebsite.loading = LoadState.Loaded;
                draftState.leadfromWebsite.data = leadfromWebsite;
            });
            return newState;
        }
        case FETCH_LEAD_FAILED: {
            const { errorMessage } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.leadfromWebsite.loading = LoadState.Failed;
                draftState.leadfromWebsite.error = errorMessage;
            });
            return newState;
        }
        // case CLEAR_LEAD: {
        //     const newState = produce(state, (draftState) => {
        //         draftState.lead.loading = LoadState.NotLoaded;
        //         draftState.lead.data = initialLead;
        //     });
        //     return newState;
        // }

        // case FETCH_LEAD_STATUS_COUNT_PROGRESS: {
        //     const newState = produce(state, (draftState) => {
        //         draftState.recordCounts.loading = LoadState.InProgress;
        //         draftState.recordCounts.list = [];
        //     });
        //     return newState;
        // }
        // case FETCH_LEAD_STATUS_COUNT_SUCCESS: {
        //     const { data } = action.payload;
        //     const newState = produce(state, (draftState) => {
        //         draftState.recordCounts.loading = LoadState.Loaded;
        //         draftState.recordCounts.list = data;
        //     });
        //     return newState;
        // }
        // case FETCH_LEAD_STATUS_COUNT_FAILED: {
        //     const newState = produce(state, (draftState) => {
        //         draftState.recordCounts.loading = LoadState.Failed;
        //         draftState.recordCounts.list = [];
        //     });
        //     return newState;
        // }

              case CLEAR_LEAD_FROM_WEBSITE_STATE: {
            return initialLeadfromWebsiteState;
        }
        default: {
            return state;
        }
    }
};
